
export default [
  {
    url: '/user/userlogin',
    type: 'post',
    response: params => {
      const { mobile,password} = params.body
      if(mobile == '18565863356' && password == '1'){
        return{
          "code": 1,
          "info": "登录成功",
          "pageno": 0,
          "pagesize": 0,
          "totalcount": 0,
          "list": {
            "lastdoc": "9131448865705066496",
            "mobile": "18565863356",
            "picture": "",
            "userid": "1788859237967757312",
            "username": "Davi"
          },
          "main": null,
          "command": "",
          "data": null
        }
      }else{
        return {
          "code": 0,
          "info": "账号密码错误",
        }
      }
      }
  　},

  {
    url: '/user/logingout',
    type: 'post',
    response: _ => {
      return {
        code: 1,
        data: 'success'
      }
    }
  },

  {
    url: '/user/logingout',
    type: 'post',
    response: _ => {
      return {
        code: 1,
        data: 'success'
      }
    }
  },

  {
    url: '/user/querydoctype',
    type: 'post',
    response: _ => {
      return {
        "code": 1,
        "info": "ok",
        "pageno": 0,
        "pagesize": 0,
        "totalcount": 0,
        "list": [
          {
            "datastatus": "1",
            "doctorid": "1758184996624826368",
            "doctype": "1",
            "doctypename": "云账号",
            "name": "云平台",
            "rolename": "云超级管理员"
          }
        ],
        "main": null,
        "command": "",
        "data": null
      }
    }
  },

  {
    url: '/user/setdoctype',
    type: 'post',
    response: _ => {
     return  {
      "code": 1,
      "info": "ok",
      "pageno": 0,
      "pagesize": 0,
      "totalcount": 0,
      "list": {
        "checkingconfirmed": 0,
        "diagnosisconfirmed": 0,
        "doctype": "3",
        "groupid": "100001,140001,200001,300001,600001,140001",
        "hospitalid": "5142864482355216384",
        "name": "超级审核管理员",
        "needcloud": "0",
        "partnershipid": "8202723025599168512",
        "rightlist": "30300001,30100001,30200001,30400001",
        "rolename": "医院报告医生",
        "show": "0",
        "showcheck": 0,
        "showdiagnosis": 0
      },
      "main": null,
      "command": "",
      "data": null
    }
   }
  },
]
